import secondaryComponents from "..";
import Images from "../../../assets/images";
import { formatCurrency } from "../../../helpers";
import useViewGenerateWaybillTable from "./useViewGenerateWaybillTable";

const ViewGenerateWaybillTable = ({
  waybills,
  view = false,
  setWaybillQty,
  waybillQty,
  items,
  control,
  selected,
  selectedAll,
  toggleAll,
  someSelected,
  toggleItem = () => {},
}) => {
  const { store_currency, instance } = useViewGenerateWaybillTable({
    waybills,
    view,
    setWaybillQty,
    waybillQty,
    items,
    control,
    selected,
    selectedAll,
    toggleAll,
    someSelected,
    toggleItem,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <div className={"h-50"} style={{ background: "#fff" }}>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        minHeight={"216px"}
      >
        <div className="text-center pt-5 pb-5">
          {view ? <img src={Images.waybill} alt="waybill" /> : null}
          <h5>
            {view
              ? "Select Store and Order ID above to select waybill Items"
              : "No waybill Items"}
          </h5>
          <p>When you do, they would appear here.</p>
        </div>
      </secondaryComponents.TableHelper>
      {waybills?.total_items_amount && !view ? (
        <div
          className="d-flex justify-content-between p-3"
          style={{ background: "#fff" }}
        >
          <h5 className="text-muted">Total:</h5>{" "}
          <h4>
            {formatCurrency({
              value: waybills?.total_items_amount,
              currencyCode: store_currency,
            })}
          </h4>
        </div>
      ) : null}
    </div>
  );
};

export default ViewGenerateWaybillTable;
